/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateMedicalHistoryErrorResponse,
  UpdateMedicalHistoryRequest,
  UpdateMedicalHistoryResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersMedicalHistory = (
  encounterId: number,
  updateMedicalHistoryRequest: UpdateMedicalHistoryRequest,
) => {
  return api<UpdateMedicalHistoryResponse>({
    url: `/api/encounters/${encounterId}/medical-history`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateMedicalHistoryRequest,
  });
};

export const getUpdateEncountersMedicalHistoryMutationOptions = <
  TError = UpdateMedicalHistoryErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersMedicalHistory>>,
    TError,
    { encounterId: number; data: UpdateMedicalHistoryRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersMedicalHistory>>,
  TError,
  { encounterId: number; data: UpdateMedicalHistoryRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersMedicalHistory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersMedicalHistory>>,
    { encounterId: number; data: UpdateMedicalHistoryRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersMedicalHistory(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersMedicalHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersMedicalHistory>>
>;
export type UpdateEncountersMedicalHistoryMutationBody = UpdateMedicalHistoryRequest;
export type UpdateEncountersMedicalHistoryMutationError = UpdateMedicalHistoryErrorResponse;

export const useUpdateEncountersMedicalHistory = <
  TError = UpdateMedicalHistoryErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersMedicalHistory>>,
      TError,
      { encounterId: number; data: UpdateMedicalHistoryRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersMedicalHistory>>,
  TError,
  { encounterId: number; data: UpdateMedicalHistoryRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersMedicalHistoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
